module.exports = __webpack_public_path__ + "img/rtc1.cde4e043.png";